import { AbstractIndexSection } from '../../abstract-index-section';
export class AbstractIndexCustom extends AbstractIndexSection {
    constructor() {
        super(...arguments);
        this.belongSiteModules = [];
        this.limit = 0;
    }
    refreshRemoteData() { }
}
